import { getServerURL } from "../shared/sharedFunctions";
import userService from "./userService";
import companyService from "./companyService";
import alertService from "./alertService";

const PolicyService = () => {
	const pub = {};

	pub.templates = [];
	pub.companyPolicies =[];
	pub.policyStats = {};

	pub.getTemplates = (companyId) => {
		return new Promise((resolve, reject) => {
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			};
			
			fetch(`${getServerURL()}/api/policies/templates/${companyId}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("templates")) {
					throw new Error("invalid response from getting policy templates");
				}

				pub.templates = data.templates;

				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};

	pub.downloadTemplate = (template) => {
		if (!template.filename) {
			alertService.show("Unable to download policy template.\nOnly PDF templates are currently supported.");
			return;
		}
		window.open(template.filename);
	};

	pub.downloadCompanyPolicy = (policy) => {
		if (!policy.filename) {
			alertService.show("Unable to download policy document.\nOnly PDF documents are currently supported.");
			return;
		}
		window.open(policy.filename);
	};

	pub.downloadCompanyEmployeePolicy = (token) => {
		let url = `${getServerURL()}/api/files/employeepolicy/${token}`;
		window.open(url);
	};
	
	pub.getCompanyPolicies = (companyId) => {
		return new Promise((resolve, reject) => {
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			};
			
			fetch(`${getServerURL()}/api/policies/${companyId}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("policies")) {
					throw new Error("invalid response from getting company policies");
				}

				pub.companyPolicies = data.policies;
				pub.policyStats = data.stats;

				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.addCompanyPolicy = (policy) => {
		return new Promise((resolve, reject) => {			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					policyFile: policy.policyFile,
					company_id: companyService.selectedCompany.id,
					name: policy.name,
					category: policy.category,
				})
			};
			
			fetch(`${getServerURL()}/api/policies`, req)
			.then((response) => {
				if (response.status === 200) {
					return pub.getCompanyPolicies(policy.company_id);
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.sendPolicies = (groupId, policyId) => {
		return new Promise((resolve, reject) => {			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					groupId: groupId,
					policyId: policyId
				})
			};
			
			fetch(`${getServerURL()}/api/policies/send`, req)
			.then(() => {
				resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.auditPolicy = (policyId, email) => {
		return new Promise((resolve, reject) => {			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					policyId: policyId,
					email: email,
				})
			};
			
			fetch(`${getServerURL()}/api/policies/audit`, req)
			.then(() => {
				resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.getAuditPolicy = async (token) => {	
		const req = {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		};
		
		const response = await fetch(`${getServerURL()}/api/policies/auditpolicy/${token}`, req);
		if (response.status !== 200) {
			throw new Error(`Error getting audit policy: ${response.status}`);
		}
		
		const data = await response.json();
		
		return {
			audit: data.audit,
			policy: data.policy
		};
	};
	
	pub.downloadAuditPolicy = async (token, policy) => {
		pub.downloadCompanyPolicy(policy);
		
		const req = {
			method: "GET",
			headers: { "Content-Type": "application/json" }
		};
		
		const response = await fetch(`${getServerURL()}/api/policies/auditdownload/${token}`, req);
		if (response.status !== 200) {
			throw new Error(`Error recording audit download: ${response.status}`);
		}
	};
	
	pub.setAuditFeedback = async (token, notes) => {
		const req = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				token: token,
				notes: notes,
			})
		};
		
		const response = await fetch(`${getServerURL()}/api/policies/auditfeedback`, req);
		if (response.status !== 200) {
			throw new Error(`Error posting audit feedback: ${response.status}`);
		}
		
		const data = await response.json();
		return data.audit;
	};

	return pub;
};

export default PolicyService();